<template lang="html">
  <app-modal @close="close" class="alert">
    <app-modal-default @close="close">
      <!-- ToDo: вставить функции для мультиязычности -->
      <template v-slot:header>
        {{ $ml.get(`Create new test`) }}
      </template>
      <template v-slot:content>
        <div class="content">
          <div class="head">
            {{ $ml.get(`Choose test type:`) }}
          </div>
          <div class="buttons">

            <div class="item soil">
              <button @click="goTo('/dashboard/tests/soil/new')" class="h-empty-btn h-btn">
                <SoilIcon/>
              </button>
              <div class="title">
                {{ $ml.get(`SOIL ANALYSIS`) }}
              </div>
            </div>

            <div class="item">
              <button
                @click="goTo('/dashboard/tests/water/new')"
                class="h-empty-btn h-btn"
              >
                <WaterIcon/>
              </button>
              <div class="title">
                {{ $ml.get(`WATER ANALYSIS`) }}
              </div>
            </div>

            <div class="item">
              <button
                @click="goTo('/dashboard/tests/tissue/new')"
                class="h-empty-btn h-btn"
              >
                <TissueIcon/>
              </button>
              <div class="title">
                {{ $ml.get(`TISSUE ANALYSIS`) }}
              </div>
            </div>

            <div class="item">
              <button
                @click="goTo('/dashboard/tests/media/new')"
                class="h-empty-btn h-btn"
              >
                <MediaIcon/>
              </button>
              <div class="title">
                {{ $ml.get(`Media analysis`) }}
              </div>
            </div>

          </div>
        </div>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import SoilIcon from './SoilIcon'
import WaterIcon from './WaterIcon'
import TissueIcon from './TissueIcon'
import MediaIcon from './MediaIcon'

export default {
  components: {
    SoilIcon,
    WaterIcon,
    TissueIcon,
    MediaIcon,
  },
  methods: {
    close() {
      this.$store.commit('tests/closeCreateModal');
    },
    goTo(path) {
      this.$router.push(path);
      this.close();
    }
  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>

.content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .head {
    padding-bottom: 25px;
    font-weight: bold;
    font-size: 16px;
    color: #4C5056;
    width: 100%;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;

    .item {
      margin: 10px;
      button {
        border-radius: 5px;
        border: 1px solid #4C5056;
        width: 160px;
        height: 140px;

        svg {
          fill: #4C5056;
        }

        &:hover {
          background-color: $mainGreen;
          border-color: $mainGreen;
          box-shadow: 0px 2px 12px rgba(73, 125, 56, 0.5);
          svg {
            fill: #fff;
          }
        }
      }
      .title {
        color: #4C5056;
        font-size: 12px;
        font-weight: bold;
        font-family: 'Roboto';
        padding: 12px 0;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
      }
    }
  }
  @media (max-width:768px) {
    .buttons {
      flex-direction: column;
    }
  }
}

</style>
